import { ApiCustomer } from '@vend/types'
import {
  hasUnknownLineItems,
  isMarkedAsUnfulfilled,
  isValidCustomer,
} from '../../../../functions/sale'
import { SaleStatus } from '../../../../models/sale.constants'
import { useAppSelector } from '../../../../state/hooks'
import {
  selectFulfilmentNoteIsInvalid,
  selectLineItems,
  selectNoteIsInvalid,
  selectSaleCustomer,
  selectSaleStatus,
  selectUnknownLineItems,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import {
  selectHasLineItemError,
  selectIsFinalisingSale,
  selectIsWaitingForWorkflows,
} from '../../../../state/slices/uiStateSlice'
import { isMissingContactInfo } from '../../sale-line-item/fulfilment/popover/LineItemFulfillmentUtils'
import { getFeatureFromCache } from '../../../../util/feature-cache'

const lifB3 = getFeatureFromCache('fulfillment_lif_b3')

const isValidUnfulfilledCustomer = (
  status: SaleStatus | undefined,
  customer: ApiCustomer | null
) => {
  if (!lifB3) {
    return true
  }
  if (!isMarkedAsUnfulfilled(status)) {
    return true
  }

  if (!isValidCustomer(customer)) {
    return false
  }

  if (!customer) {
    return false
  }

  return !isMissingContactInfo(customer)
}

export const useCanTransitionToPaymentScreen = () => {
  const lineItems = useAppSelector(selectLineItems)
  const status = useAppSelector(selectSaleStatus)
  const customer = useAppSelector(selectSaleCustomer)
  const unknownLineItems = useAppSelector(selectUnknownLineItems)
  const lineItemError = useAppSelector(selectHasLineItemError)
  const isFinalisingSale = useAppSelector(selectIsFinalisingSale)
  const isWaitingForWorkflows = useAppSelector(selectIsWaitingForWorkflows)
  const validCustomer = isValidUnfulfilledCustomer(status, customer)
  const fulfilmentNoteInvalid = useAppSelector(selectFulfilmentNoteIsInvalid)
  const lineItemNoteInvalid = useAppSelector(selectNoteIsInvalid)

  return (
    !isFinalisingSale &&
    !isWaitingForWorkflows &&
    lineItems.length &&
    !hasUnknownLineItems({ unknownLineItems }) &&
    !lineItemError &&
    !fulfilmentNoteInvalid &&
    !lineItemNoteInvalid &&
    validCustomer
  )
}
